import { useMemo } from "react";

import type { CryptoOrderType } from "~/v2/constants/cryptoOrder";
import { CRYPTO_LOCALE_OPTIONS } from "../utils";

interface GetCryptoEstimatedCostParams {
  isNotional: boolean;
  quantity: number;
  orderType: CryptoOrderType;
  limitPrice: number | undefined;
  midPriceValue: number;
}

export const getCryptoEstimatedCost = ({
  isNotional,
  quantity,
  orderType,
  limitPrice,
  midPriceValue,
}: GetCryptoEstimatedCostParams): string => {
  if (isNotional) {
    if (!quantity) {
      return "-";
    }
    return quantity.toLocaleString("en-US", CRYPTO_LOCALE_OPTIONS);
  }

  if (Number.isNaN(quantity) || !quantity) {
    return "-";
  }

  if (orderType === "limit" || orderType === "stop_limit") {
    if (!limitPrice) {
      return "-";
    }
    return (limitPrice * quantity).toLocaleString(
      "en-US",
      CRYPTO_LOCALE_OPTIONS,
    );
  }

  return (midPriceValue * quantity).toLocaleString(
    "en-US",
    CRYPTO_LOCALE_OPTIONS,
  );
};

export const useCryptoEstimatedCost = ({
  isNotional,
  quantity,
  orderType,
  limitPrice,
  midPriceValue,
}: GetCryptoEstimatedCostParams) => {
  const estimatedCost = useMemo(
    () =>
      getCryptoEstimatedCost({
        isNotional,
        quantity,
        orderType,
        limitPrice,
        midPriceValue,
      }),
    [isNotional, quantity, orderType, limitPrice, midPriceValue],
  );

  return { estimatedCost };
};
